import { Constants } from '../../shared/Constants';

/**
 * Filter Management Logic
 */
export const DataTableFilters = {
    /**
     * Initializes the core popover-based column filtering.
     */
    init: function(adapter) {
        const self = adapter;
        const $table = $(self._instance.table().node());
        
        // Create a singleton popover element if it doesn't exist
        let $popover = $('.dt-filter-popover');
        if ($popover.length === 0) {
            $popover = $(`
                <div class="dt-filter-popover">
                    <div class="dt-filter-popover-header">
                        <span class="dt-filter-popover-title">Filter Column</span>
                        <button type="button" class="dt-filter-popover-close"><i class="bi bi-x-lg"></i></button>
                    </div>
                    <div class="dt-filter-popover-body"></div>
                    <div class="dt-filter-popover-footer">
                        <button type="button" class="btn btn-clear">Clear</button>
                        <button type="button" class="btn btn-apply">Apply</button>
                    </div>
                </div>
            `).appendTo('body');

            // Singleton event listeners attached once
            $popover.on('click', '.dt-filter-popover-close', () => {
                const targetAdapter = $popover.data('target-adapter');
                if (targetAdapter) targetAdapter._cleanupPickers($popover.find('.dt-filter-popover-body'));
                $('.popover-open').removeClass('popover-open');
                $popover.hide();
            });

            $popover.on('click', '.btn-apply', function () {
                const colIdx = $popover.data('target-col');
                const $toggle = $popover.data('target-toggle');
                const targetAdapter = $popover.data('target-adapter');
                const col = targetAdapter._config.columns[colIdx];
                
                targetAdapter._applyFilter($popover.find('.dt-filter-popover-body'), colIdx, col, $toggle);
                
                $('.popover-open').removeClass('popover-open');
                $popover.hide();
            });

            $popover.on('click', '.btn-clear', function () {
                const colIdx = $popover.data('target-col');
                const $toggle = $popover.data('target-toggle');
                const targetAdapter = $popover.data('target-adapter');
                const col = targetAdapter._config.columns[colIdx];

                targetAdapter._clearFilter(colIdx, col, $toggle);

                $('.popover-open').removeClass('popover-open');
                $popover.hide();
            });

            $popover.on('keypress', '.form-control', function (e) {
                if (e.which === 13) {
                    $popover.find('.btn-apply').click();
                }
            });

            $(document).on('mousedown.dt-filter', function (e) {
                if (!$popover.is(e.target) && $popover.has(e.target).length === 0 && !$(e.target).closest('.dt-column-filter-toggle').length) {
                    const targetAdapter = $popover.data('target-adapter');
                    if (targetAdapter) targetAdapter._cleanupPickers($popover.find('.dt-filter-popover-body'));
                    $('.popover-open').removeClass('popover-open');
                    $popover.hide();
                }
            });
        }

        // Inject filter toggles into relevant headers
        self._instance.columns().indexes().each((idx) => {
            const col = self._config.columns[idx];
            if (col && col.filterType) {
                const headerEl = self._instance.column(idx).header();
                if (!headerEl) return;

                const $header = $(headerEl);
                $header.addClass('dt-has-filter');
                let $toggle = $header.find('.dt-column-filter-toggle');
                
                if ($toggle.length === 0) {
                    $toggle = $('<div class="dt-column-filter-toggle" title="Filter this column"><i class="bi bi-funnel"></i></div>');
                    $header.append($toggle);
                }

                $toggle.off('click.dt-filter').on('click.dt-filter', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const $thisToggle = $(this);
                    const colIdx = idx;
                    const colTitle = col.title || 'Column';
                    
                    if ($thisToggle.hasClass('popover-open')) {
                        $('.popover-open').removeClass('popover-open');
                        $popover.hide();
                        return;
                    }

                    $('.popover-open').removeClass('popover-open');
                    $popover.hide();

                    $popover.find('.dt-filter-popover-title').text(`Filter: ${colTitle}`);
                    const $popoverBody = $popover.find('.dt-filter-popover-body');
                    self._cleanupPickers($popoverBody);
                    $popoverBody.empty();
                    self._renderFilterBody($popoverBody, idx, col);

                    const offset = $thisToggle.offset();
                    $popover.css({
                        top: offset.top + $thisToggle.outerHeight() + 5,
                        left: Math.min(offset.left, $(window).width() - $popover.outerWidth() - Constants.UI.SAFE_MARGIN),
                        position: 'absolute',
                        zIndex: Constants.UI.Z_INDEX
                    }).show();

                    $thisToggle.addClass('popover-open');
                    $popover.data('target-col', colIdx);
                    $popover.data('target-toggle', $thisToggle);
                    $popover.data('target-config', col.filterConfig);
                    $popover.data('target-instance', self._instance);
                    $popover.data('target-adapter', self);

                    setTimeout(() => {
                        $popoverBody.find('.form-control').first().focus();
                    }, 50);
                });
            }
        });
    },

    renderBody: function(adapter, $body, colIdx, col) {
        const type = col.filterType;
        const state = adapter._advancedFilters[colIdx] || {};
        const currentSearch = adapter._instance.column(colIdx).search();

        switch (type) {
            case Constants.FilterType.RANGE:
                $body.append(`
                    <div class="dt-filter-range-group">
                        <div class="mb-2">
                            <label class="small text-muted mb-1">Minimum</label>
                            <input type="number" class="form-control form-control-sm dt-filter-min" placeholder="Min" value="${state.min || ''}">
                        </div>
                        <div>
                            <label class="small text-muted mb-1">Maximum</label>
                            <input type="number" class="form-control form-control-sm dt-filter-max" placeholder="Max" value="${state.max || ''}">
                        </div>
                    </div>
                `);
                break;

            case Constants.FilterType.DATE_RANGE:
                $body.append(`
                    <div class="dt-filter-range-group">
                        <div class="mb-2">
                            <label class="small text-muted mb-1">From Date</label>
                            <input type="text" class="form-control form-control-sm dt-filter-min" value="${state.min || ''}" placeholder="Select date...">
                        </div>
                        <div>
                            <label class="small text-muted mb-1">To Date</label>
                            <input type="text" class="form-control form-control-sm dt-filter-max" value="${state.max || ''}" placeholder="Select date...">
                        </div>
                    </div>
                `);

                // Integration: Use GenericDatepicker if available
                if (window.GenericDatepickerBuilder) {
                    $body.find('.dt-filter-min').genericDatepicker(builder => {
                        builder.withDateOnly();
                        if (state.min) builder.withValue(state.min);
                    });
                    $body.find('.dt-filter-max').genericDatepicker(builder => {
                        builder.withDateOnly();
                        if (state.max) builder.withValue(state.max);
                    });
                }
                break;

            case Constants.FilterType.SELECT:
                const uniqueValues = adapter._instance.column(colIdx).data().unique().sort().toArray();
                let options = '<option value="">All Values</option>';
                uniqueValues.forEach(val => {
                    if (val === null || val === undefined || val === '') return;
                    const selected = currentSearch === val ? 'selected' : '';
                    options += `<option value="${val}" ${selected}>${val}</option>`;
                });
                $body.append(`<select class="form-control form-select dt-filter-select">${options}</select>`);
                break;

            case 'custom':
                if (col.filterConfig && typeof col.filterConfig.render === 'function') {
                    col.filterConfig.render($body, currentSearch);
                }
                break;

            default:
                $body.append(`<input type="text" class="form-control dt-filter-input" placeholder="Search..." value="${currentSearch}">`);
        }
    }
};
